/* eslint-disable no-bitwise */
// String utility methods

export function getPathElement(path, elementIndex) {
  if (path) {
    const pathElements = path.split('/')
    if (pathElements[0] === '') {
      pathElements.splice(0, 1)
    }
    return pathElements.length > elementIndex ? pathElements[elementIndex] : ''
  }
  return ''
}

export function getLastPathElement(path) {
  if (path && path.indexOf('/') !== -1) {
    return path.substring(path.lastIndexOf('/') + 1)
  }
  return path
}

export function keyValueStringToJSObject(string, delimiter) {
  const jsObject = {}
  const pairs = string.split(delimiter)

  pairs.forEach((pair) => {
    const key = pair.split('=')[0]
    const value = pair.split('=')[1]
    jsObject[key] = value
  })

  return jsObject
}

export function isJSON(string) {
  if (!isString(string)) {
    return false
  }
  try {
    JSON.parse(string)
    return true
  } catch (e) {
    return false
  }
}

export function isString(obj) {
  const type = Object.prototype.toString.call(obj).toLowerCase()
  if (type.includes('string')) {
    return true
  }
  return false
}

export function toNonNull(string) {
  if (!string) {
    return ''
  }
  return string
}

export function getIdElement(id) {
  if (id && id.indexOf('.') !== -1) {
    return id.substring(id.lastIndexOf('.') + 1)
  }
  return id
}

export function capitalizeFirstLetter(string) {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : null
}

export function lowerCaseFirstLetter(string) {
  return string ? string.charAt(0).toLowerCase() + string.slice(1) : null
}

export function getFirstLetter(string) {
  return string ? string.charAt(0) : null
}

export function buildUriQueryList(key, values) {
  if (key && values) {
    return values
      .filter((value) => value != null)
      .map((value) => `${key}=${value}`)
      .join('&')
  }
  return ''
}

export const getEnumAbbreviation = (field) => {
  if (field) {
    return field
      .split('_')
      .filter((token) => token !== 'TO' && token !== 'THE')
      .map((token) => token[0])
      .map((firstChar) => firstChar.toUpperCase())
  }
  return ''
}

export const camelCaseToReadable = (text) => {
  // no side-effects
  if (!text) {
    return ''
  }
  return (
    text
      // inject space before the upper case letters
      .replace(/([A-Z])/g, (match) => {
        return ` ${match}`
      })
      // replace first char with upper case
      .replace(/^./, (match) => {
        return match.toUpperCase()
      })
      // Trim outer spaces
      .trim()
  )
}

export function toTitleCase(text) {
  const output = text
    .split(/[.,_/ -]/)
    .map((item) => {
      const word = item.charAt(0).toUpperCase() + item.substring(1).toLowerCase()
      return word
    })
    .join(' ')
  return output
}

export function enumToCamelCase(text, firstLetterLowerCase = false) {
  let output = text
    .split(/[.,_/ -]/)
    .map((item) => {
      const word = item.charAt(0).toUpperCase() + item.substring(1).toLowerCase()
      return word
    })
    .join('')
  if (firstLetterLowerCase) {
    output = lowerCaseFirstLetter(output)
  }
  return output
}

export function enumToReadableCamelCase(text, firstLetterLowerCase = false) {
  let output = text
    .split(/[.,_/ -]/)
    .map((item) => {
      const word = item.charAt(0).toUpperCase() + item.substring(1).toLowerCase()
      return `${word} `
    })
    .join('')
  if (firstLetterLowerCase) {
    output = lowerCaseFirstLetter(output)
  }
  return output
}

export const printValueOrBooleanReadable = (value, yes = 'Yes', no = 'No') => {
  if (value == null) {
    return ''
  }
  if (typeof value === 'boolean') {
    return value ? yes : no
  }
  if (value.toLowerCase() === 'true') {
    return yes
  }
  if (value.toLowerCase() === 'false') {
    return no
  }
  return value
}

export function getBooleanDisplayValue(boolean, yes = 'Yes', no = 'No') {
  if (boolean === undefined || boolean === null || typeof boolean !== 'boolean') {
    return null
  }
  return boolean ? yes : no
}

const getComparator = (fieldName, sortOrder) => (a, b) =>
  sortOrder === 'asc' ? `${b[fieldName]}`.localeCompare(a[fieldName]) : `${a[fieldName]}`.localeCompare(b[fieldName])

export const getSortedArr = (arrayToBeSorted, fieldName, sortOrder) => {
  return arrayToBeSorted.sort(getComparator(fieldName, sortOrder))
}

export const getNewNamePart = (type, value) => ({
  type: `http://gedcomx.org/${type}`,
  value,
})

export const getGender = (value) => ({
  type: `http://gedcomx.org/${value}`,
})

export const getNewOfficialType = (type) => `http://api.familysearch.org/temple/${type}`

export const getPidFromIdentifier = (identifiersContainer) => {
  let pid = null
  if (identifiersContainer) {
    const identifiers = Object.entries(identifiersContainer)
    identifiers.forEach(([key, value]) => {
      if (key === 'http://api.familysearch.org/temple/USYS_ID') {
        pid = getIdElement(value[0])
      }
    })
  }
  return pid
}

export const setIdInIdentifiers = (identifiersContainer, newValue, identifier) => {
  const identifiers = Object.entries(identifiersContainer)
  if (identifiers.some(([key]) => key === identifier)) {
    identifiers.forEach(([key]) => {
      if (key === identifier) {
        if (getIdElement(newValue) === '') {
          delete identifiersContainer[key]
        } else {
          const identifiersIdCopy = [...identifiersContainer[key]]
          identifiersIdCopy[0] = newValue
          identifiersContainer[key] = identifiersIdCopy
        }
      }
    })
  } else if (newValue) {
    const newIdentifier = [identifier, [newValue]]
    identifiers.push(newIdentifier)
    identifiers.forEach(([key]) => {
      if (key === identifier) {
        identifiersContainer[identifier] = [newValue]
      }
    })
  }
}

export const getMrnFromIdentifier = (identifiersContainer) => {
  let mrn = null
  if (identifiersContainer) {
    const identifiers = Object.entries(identifiersContainer)
    identifiers.forEach(([key, value]) => {
      if (key === 'http://api.familysearch.org/temple/MEMBERSHIP_RECORD_NUMBER') {
        mrn = value[0]
      }
    })
  }
  return mrn
}

export const getSourceSystemIdFromIdentifier = (identifiersContainer) => {
  let sourceSystemId = null
  if (identifiersContainer) {
    const identifiers = Object.entries(identifiersContainer)
    identifiers.forEach(([key, value]) => {
      if (key === 'http://api.familysearch.org/temple/SOURCE_SYSTEM_ID') {
        sourceSystemId = value[0]
      }
    })
  }
  return sourceSystemId
}

export const setMrnFromIdentifier = (identifiers, newMrn) => {
  if (identifiers) {
    identifiers.forEach((identifier, index) => {
      if (identifier.includes('-')) {
        identifiers[index] = newMrn
      }
    })
  }
  return identifiers
}

export const getFullTextFromNameParts = (parts) => {
  let result = ''
  if (parts) {
    parts.forEach((part, index) => {
      result += part.value
      if (index !== parts.length) {
        result += ' '
      }
    })
  }

  return result
}

export const getNewFactWithVal = (type, value) => ({
  type,
  value,
})

export const getNewFactWithDate = (id, type, date, place) => ({
  id,
  type,
  date: {
    original: date,
  },
  place: {
    original: place,
  },
})

export function getNumericalIdFromId(id) {
  const ALPHABET = 'M9S3Q7W4HCZ8D6XFNJVK2LGP5RTYB1'
  const NUMBER_BASE = ALPHABET.length
  const idAr = String(id).replace('-', '').toUpperCase().split('')

  // check to see if id is displayable id
  if (id && id.includes('-') && (id.length === 8 || id.length === 9)) {
    let result = 0
    let isEncodingNotValid = false
    idAr.forEach((idCh) => {
      const idx = ALPHABET.indexOf(idCh)
      if (idx === -1) {
        isEncodingNotValid = true
      } else {
        result = result * NUMBER_BASE + idx
      }
    })
    return isEncodingNotValid ? 0 : result
  }
  return null
}

export function isNumber(object) {
  // eslint-disable-next-line no-restricted-globals
  return !isNaN(object)
}

export function equalsTreatEmptyNullUndefinedTheSame(str1, str2) {
  str1 = str1 || null // empty string, null, undefined will be treated equally
  str2 = str2 || null // empty string, null, undefined will be treated equally
  return str1 === str2
}

export function capitalizeRanAndId(str) {
  // Check if "ran" or "id" is present in the string, ignoring case
  if (/\bran\b/i.test(str)) {
    str = str.replace(/\bran\b/gi, 'RAN')
  }
  if (/\bid\b/i.test(str)) {
    str = str.replace(/\bid\b/gi, 'ID')
  }

  return str
}

export function getStringPixelWidth(text, font) {
  const span = document.createElement('span')
  span.style.font = font
  span.textContent = text
  document.body.appendChild(span)
  const width = span.getBoundingClientRect().width
  document.body.removeChild(span)
  return width
}

export function extractSubstringBetweenParentheses(inputString) {
  let substrings

  let startIndex = inputString.indexOf('(')
  while (startIndex !== -1) {
    const endIndex = inputString.indexOf(')', startIndex + 1)
    if (endIndex !== -1) {
      substrings = inputString.slice(startIndex + 1, endIndex)
      startIndex = inputString.indexOf('(', endIndex + 1)
    } else {
      break
    }
  }

  return substrings
}

// Lifted from https://stackoverflow.com/questions/10420352/converting-file-size-in-bytes-to-human-readable-string
export function byteSizeToHumanReadable(bytes, si = false, dp = 1) {
  const thresh = si ? 1000 : 1024

  if (Math.abs(bytes) < thresh) {
    return `${bytes} B`
  }

  const units = si
    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
  let u = -1
  const r = 10 ** dp

  do {
    bytes /= thresh
    ++u
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1)

  return `${bytes.toFixed(dp)} ${units[u]}`
}

export function getHash(str) {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i) // Get the character's numeric ID (Unicode)
    hash = (hash << 5) - hash + char // Shift hash left by 5 bits and subtract the original hash, then add the character code
    hash |= 0 // Force the result into a 32-bit signed integer
  }
  return hash
}
